export default {
    unknown: {
        title: "An unknown error occured",
        message: "Sorry - we can't provide any details about this error.<br><br>But if it happens again, please get in touch and let us know when it happened, so we can try to fix it.",
        url: "https://www.willowlife.co.uk/contact/",
        buttonText: "Contact us"
    },
    "booking-post-processing-failed": {
        title: "There was a problem processing your booking",
        message: "Sorry - your bookings were provisionally reserved, and any payment required was made successfully; but there was a problem either adding your details to our database of clients, or marking your booking as confirmed.<br><br>Please contact us so we can make sure you're properly booked in.",
        url: "https://www.willowlife.co.uk/contact/",
        buttonText: "Contact us"
    },
    "session-timed-out": {
        title: "It looks like your session timed out",
        message: "Sorry - it looks like you were inactive for a while, so your session has timed out.<br><br>If you like you can click the button below to start again.<br><br>If this problem persists, please contact us so we can investigate.",
        url: "https://www.willowlife.co.uk/about-you/",
        buttonText: "Start again"
    },
    "success-page_invalid-url": {
        title: "Invalid web address",
        message: "It looks like you're trying to visit our Order Summary page, but you didn't arrive there from our payment gateway.<br><br>The Order Summary page is not directly accessible.",
        url: "https://www.willowlife.co.uk/about-you/",
        buttonText: "Start again"
    }
};
